
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M7.00001 24H9.00001V22H7.00001V24ZM12 13C13.66 13 14.99 11.66 14.99 10L15 4C15 2.34 13.66 1 12 1C10.34 1 9.00001 2.34 9.00001 4V10C9.00001 11.66 10.34 13 12 13ZM11 24H13V22H11V24ZM15 24H17V22H15V24ZM18.08 10C17.66 10 17.31 10.3 17.25 10.71C16.88 13.32 14.53 15.1 12 15.1C9.47001 15.1 7.12001 13.33 6.75001 10.71C6.69001 10.3 6.33001 10 5.92001 10C5.40001 10 5.00001 10.46 5.07001 10.97C5.53001 13.93 8.03001 16.27 11 16.72V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19V16.72C15.96 16.28 18.47 13.93 18.93 10.97C19 10.46 18.6 10 18.08 10Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-settings-voice`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSettingsVoice

    ```js
    <b-new-b-icon-settings-voice />
    ```
</docs>


